<template>
  <div class="dynamic">
    <!--轮播图-->
    <div class="inbanner clearfix">
      <div class="swiper-box">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper-wrapper" @slide-change-transition-end="handleClickSlide">
          <swiper-slide v-for="(item, index) in swiperList" :key="index" class="swioer-item" swiper-animate-effect="shutter2">
            <div class="swiper-box">
              <img :src="item.url" alt="" />
            </div>
          </swiper-slide>
          <div class="swiper-pagination"
               slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!--操作区域-->
    <div style="position: absolute;display: flex;flex-direction: row;justify-content: space-around;margin-top:-220px;margin-left:250px;z-index: 9;">
      <div style="width:300px;height:200px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <div style="width:250px;height:50px;border-radius:90px;display: flex;flex-direction: row;justify-content:center;padding:10px;align-items: center;background: #3cb270">
          <div style="display: flex;flex-direction: row;align-items: center;">
            <div><img :src="require('../assets/images/android.png')" style="width:25px;height:25px;" /></div>
            <div style="flex:1;margin-left:8px;font-weight: 500;font-size:14px;color:white;">Android Download</div>
          </div>
        </div>
        <div style="margin-top:20px;">
          <img  style="width:120px;" :src="require('../assets/images/httpsjzhpush.bbjt.cc.png')" alt="" />
        </div>
      </div>
      <div style="width:300px;height:200px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <div style="width:250px;height:50px;border-radius:90px;display: flex;flex-direction: row;justify-content: space-around;padding:10px;align-items: center;background: #068ce1">
          <div style="display: flex;flex-direction: row;align-items: center;">
            <div><img :src="require('../assets/images/ios-icon.png')" style="width:25px;height:25px;" /></div>
            <div style="flex:1;margin-left:8px;font-weight: 500;font-size:14px;color:white;">IOS Download</div>
          </div>
        </div>
        <div style="margin-top:20px;">
          <img style="width:120px;" :src="require('../assets/images/ios_down_url.png')" alt="" />
        </div>
      </div>
    </div>
    <div style="width:86%;">
      <!--内容展示-->
      <div style="margin-left:10%;">
        <img :src="require('../assets/images/jzhjs.jpg')" alt="" />
      </div>
      <!--内容介绍-->
      <div style="margin-left:20%;">

        <div style="font-size:20px;padding:10px;">应用描述</div>

        <div style="font-size:16px;padding:15px;">标题：【探索未来，轻松生活—佳智惠，您的全能助手】</div>

        <div style="padding:20px;font-size:15px;line-height:30px;text-indent: 2em">想象一下，一款集智能搜索、便捷操作与高效生活于一身的应用程序正在等待您的下载。这就是我们的【佳智惠】，一款专为现代人打造的安卓神器，让科技融入日常，让生活更加精彩。 首先，只需轻点【安装】按钮或者扫描下方的二维码，您就可以在智能手机上快速、免费下载【佳智惠】的apk版本。无论您是安卓设备爱好者，还是寻找实用工具的新手，这款应用都能无缝适应，确保您的体验流畅无阻。 一旦安装完毕，打开应用程序，您将被其直观的界面和丰富的功能所吸引。【佳智惠】的强大搜索引擎，能帮您迅速找到所需的信息，无论是日常生活问题，还是专业咨询，都能轻松找到答案。比如，一键搜索美食食谱，或是查询最新的科技资讯，一切触手可及。 此外，我们特别注重用户体验，【佳智惠】还提供了个性化推荐服务，根据您的使用习惯，智能推送适合的内容，节省您的时间，让生活更加有序。而且，对于安卓游戏和安卓应用的爱好者，这里更是天堂，您可以直接从应用内发现并下载热门游戏和工具，无需离开这个一站式平台。 别再犹豫了，点击【安装】，让【佳智惠】成为您生活中不可或缺的好伙伴。现在就行动起来，开启这场科技与智慧的探索之旅吧！让我们一起，佳智惠，让生活更简单！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import DynamicBox from '../components/common/dynamicBox.vue';
export default {
  props: [],
  data () {
    return {
      tabList: [
        { name: 'bbdt' },
        { name: 'hydt' },
        { name: 'bbbk' },
      ],
      location: '',
      tabShou: 0,
      dynamic: [],
      dynamics: [],
      currentPage1: 5,
      total: null,
      page: 1,
      count: 5,
      information: {},
      langtype: 0,
      swiperOption: {
        loop: true, // 是否循环轮播
        autoplay: true, // 是否可以自动轮播
        slidesPerView: 1, // 可是区域内可展示多少个块
        spaceBetween: 30, // 块之间间隔距离
        initialSlide: 0, // 默认初始显示块
        freeMode: false,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      swiperList: [
        {
          id:1,
          url:require('../assets/images/appdown_back.jpg')
        }
      ],
    }
  },
  name: "app",
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    },
  },
  components: { swiper, swiperSlide, DynamicBox },
  created () {
    switch (localStorage.getItem('lang')) {
      case "zh":
        this.langtype = 0;
        break;
      case "en":
        this.langtype = 1;
        break;
      case "es":
        this.langtype = 6;
        break;
      case "ru":
        this.langtype = 2;
        break;
      case "de":
        this.langtype = 3;
        break;
      case "fr":
        this.langtype = 4;
        break;
      case "ar":
        this.langtype = 5;
        break;
    }
    this.tabList.forEach((item, index) => {
      item.name = this.$t('breadcrumb.' + item.name)
    })
    let _this = this
    window.addEventListener("setItemEvent", function (e) {
      //e.key : 是值发生变化的key
      if (e.key === "sharing") {
        setTimeout(() => {
          if (e.newValue == '行业动态') {
            _this.tabShou = 1
            _this.companyList(15)
          } else if (e.newValue == '佳智惠百科') {
            _this.tabShou = 2
            _this.companyList(74)
          } else {
            _this.tabShou = 0
            _this.companyList(14)
          }
        }, 500)
      }
    })
  },
  mounted () {
    this.location = this.$t('breadcrumb.bbap')
    if (this.$route.query.tab) {
      this.addTab(this.tabList[this.$route.query.tab], this.$route.query.tab)
    }
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      this.$wow.init();
    });
  },
  methods: {
    handleClickSlide () {
    },
    async getTopImg () {
      let information = await this.api.get(this.apiPath.information, {});
      this.information = information[0]
      let res = await this.api.get(this.apiPath.dynamicSwiper, {});
      console.log("轮播图",res)
      this.swiperList = res;
      if (res.items.length === 0) {
        this.swiperList.items.push({
          img: res.img
        })
      }
    },
    async companyList (id) {
      let data = {
        layout_id: id,
        page: this.page,
        count: this.count
      }
      let companyDynamic = await this.api.post(this.apiPath.editor, data);
      this.dynamic = companyDynamic.items
      this.dynamics = companyDynamic
      console.log(this.dynamics)
      this.total = companyDynamic.total
      this.currentPage1 = companyDynamic.page + 1
    },
    addTab (item, index) {
      //tab切换
      this.location = item.name
      console.log(this.location)
      this.tabShou = index
      this.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      // 每页多少条
      this.count = val
      this.getList()
    },
    handleCurrentChange (val) {
      //当前页
      this.page = val
      this.getList()
    },
    getList () {
      //判断当前tab获取相应数据
      if (this.tabShou == 0) {
        this.companyList(14)
      } else if (this.tabShou == 1) {
        this.companyList(15)
      } else {
        this.companyList(74)
      }
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.pic {
  img {
    width: 100%;
  }
}
.center {
  padding: 20px 100px;
  .news-box {
    width: 100%;
    margin-top: 10px;
    border-top: 1px solid #eee;
    padding-top: 20px;
    .tabs {
      text-align: center;
      .title {
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #7f0114;
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 5px;
        color: #fff;
      }
      ul {
        display: flex;
        border-bottom: 1px solid #7f0114;
        margin-bottom: 40px;
      }
      ul li {
        width: 100px;
        height: 40px;
        line-height: 40px;
        color: #000;
        font-size: 18px;
        cursor: pointer;
      }
      ul .active {
        background: #7f0114;
        color: #fff;
        transition: 0.5s;
      }
      img {
        width: 200px;
        height: 150px;
      }
    }
    .news-cen {
      width: 100%;
      margin: 0 auto;
    }
  }
}
@media screen and (max-width: 750px) {
  .img img {
    height: 200px;
    object-fit: cover;
  }
  .breadcrumb {
    display: none;
  }
  .center {
    padding: 0;
  }
}
</style>
